import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerStoresState } from "./types";
import { fetchPartnerStoresStatistics } from "./partner-stores-thunk";
import { ErrorType } from "@/shared/types";

const currentDate = new Date()

const initialState: PartnerStoresState = {
    partnersStoresStatistics: {},
    isLoading: false,
    isFirstLoad: true,
    error: null,
    selectedPartner: null,
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
}

const partnerStoresSlice = createSlice({
    name: 'partnerStores',
    initialState,
    reducers: {
        setSelectedPartner(state, action: PayloadAction<string | null>) {
            state.selectedPartner = action.payload
        },
        setStartDate(state, action: PayloadAction<Date>) {
            state.startDate = action.payload
        },
        setEndDate(state, action: PayloadAction<Date>) {
            state.endDate = action.payload
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchPartnerStoresStatistics.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchPartnerStoresStatistics.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFirstLoad = false
            state.partnersStoresStatistics = action.payload
            state.error = null
        })
        .addCase(fetchPartnerStoresStatistics.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload as ErrorType ?? null
        })
    },
})

export default partnerStoresSlice.reducer
export const { setSelectedPartner, setEndDate, setStartDate } = partnerStoresSlice.actions